export const convertHoursToMinutes = (hours: number, minutes: number) => {
  return hours * 60 + minutes;
};

export const convertMinutesToHours = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const newMinutes = minutes % 60;

  return { hours, minutes: newMinutes };
};
